module.exports = __webpack_public_path__ + "static/media/popovicova_and_kuzmova.4c6e081a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/popovicova_and_kuzmova.jpg
// module id = 561
// module chunks = 0